import React from "react";
import Button, { ButtonProps } from "web/react/components/button/button";

type PrimaryButtonProps = Omit<ButtonProps, "styleType">;

export default function PrimaryButton(props: PrimaryButtonProps): JSX.Element {
    return <Button styleType="primary" {...props} />;
}
